export interface CostCenter {
	Id: number | null;
	Name: string;
	Description: string;
	Bud: number;
	DeptId: string;
	EndUser: string;
	Comments: string;
	Active: boolean;
}

export const COST_CENTER_INITIAL_VALUES: CostCenter = {
	Id: null,
	Name: "",
	Description: "",
	Bud: 0,
	DeptId: "",
	EndUser: "",
	Comments: "",
	Active: true,
};
